import { Create, getValueFromEvent, useFileUploadState, useForm, useSelect } from "@refinedev/antd";
import { BookOutlined, InboxOutlined, CloudServerOutlined } from "@ant-design/icons";
import { Form, Select, Tag, Upload, Space } from "antd";
import { IResourceComponentsProps, useApiUrl } from "@refinedev/core";

import { IPhysicalBooks, IVessel } from "interfaces";
import { FormSection, FormFieldGrid } from "components/form";
import React from "react";

export const PhysicalBooksCreate: React.FC<IResourceComponentsProps> = () => {
  const [isVesselSelected, setIsVesselSelected] = React.useState(false);
  const [isFileUploaded, setIsFileUploaded] = React.useState(false);

  const {
    formProps,
    saveButtonProps,
    formLoading: isLoading,
  } = useForm<IPhysicalBooks>({ redirect: "list" });

  const { onChange, isLoading: isFileUploading } = useFileUploadState();
  const apiUrl = useApiUrl();

  const { selectProps: vesselSelectProps } = useSelect<IVessel>({
    resource: "vessel",
    optionLabel: "name",
    optionValue: "id",

    pagination: {
      mode: "server"
    }
  });

  function onVesselSelection(e: any) {
    setIsVesselSelected(true);
  }

  function onFileUpload(e: any) {
    setIsFileUploaded(true);
    onChange(e);
  }

  const props = {
    name: "file",
    multiple: false,
    maxCount: 1,
    action: `${apiUrl}/upload/physical/books`,
    onChange: onFileUpload,
  };

  return (
    <Create
      breadcrumb={false}
      saveButtonProps={{
        ...saveButtonProps,
        disabled:
          isVesselSelected && isFileUploaded && !isFileUploading ? false : true,
      }}
      headerProps={{
        onBack: () => window.history.back(),
        title: "Standard Library Publications",
        subTitle: "setup new standard library publications",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
    >
      <Form {...formProps} layout="vertical" initialValues={{}}>
        <Space direction="vertical" size={24} style={{ width: "100%" }}>
          <FormSection
            title="Vessel Selection"
            subtitle="Select vessel for physical books"
            icon={<CloudServerOutlined />}
            variant="elevated"
          >
            <FormFieldGrid columns={1}>
              <Form.Item
                label="Vessel"
                name={["vessel", "id"]}
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Select {...vesselSelectProps} onSelect={onVesselSelection} />
              </Form.Item>
            </FormFieldGrid>
          </FormSection>
          <FormSection
            title="File Upload"
            subtitle="Upload physical books data"
            icon={<BookOutlined />}
            variant="elevated"
          >
            <Form.Item
              name="file"
              valuePropName="file"
              getValueFromEvent={getValueFromEvent}
            >
              <Upload.Dragger {...props} listType="picture">
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag & drop file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single upload of standard library publications for
                  vessel
                </p>
              </Upload.Dragger>
            </Form.Item>
          </FormSection>
        </Space>
      </Form>
    </Create>
  );
};
